import { Application } from "pixi.js";
import { debounce } from "../../utils";
import ConnectionsLayer from "./ConnectionsLayer";
class AnimatedDotsConnections {
    constructor(el, options, backgroundOptions = null, autoStart = false) {
        this.el = el;
        this.width = this.el.clientWidth;
        this.prevWidth = this.width;
        this.height = this.el.clientHeight;
        this.dpr = window.devicePixelRatio || 1;

        this.app = new Application({
            width: this.width,
            height: this.height,
            antialias: true,
            backgroundAlpha: 0,
            autoDensity: true,
            resolution: this.dpr,
            powerPreference: 'high-performance',
        })

        this.el.appendChild(this.app.view);

        if(options) {
            this.options = { ...options, app: this.app, width: this.width, height: this.height };
            this.foregroundLayer = new ConnectionsLayer(this.options);
        }

        if(backgroundOptions) {
            this.backgroundOptions = { ...backgroundOptions, app: this.app, width: this.width, height: this.height };
            this.backgroundLayer = new ConnectionsLayer(this.backgroundOptions);
        }

        window.addEventListener('resize', debounce(() => {
            this.handleResize();
        }, 200));

        this.app.ticker.add(() => this.animate());
        if(!autoStart) {
            this.app.ticker.stop();
        }
        this.animate();
    }

    handleResize() {
        this.width = this.el.clientWidth;

        if (this.width === this.prevWidth) return;
        this.prevWidth = this.width;
        this.height = this.el.clientHeight;
        this.app.renderer.resize(this.width, this.height);

        if(this.foregroundLayer) {
            this.foregroundLayer.handleResize(this.width, this.height);
        }

        if(this.backgroundLayer) {
            this.backgroundLayer.handleResize(this.width, this.height);
        }
    }

    startAnimation() {
        this.app.ticker.start();
    }

    stopAnimation() {
        this.app.ticker.stop();
    }

    animate() {
        if(this.foregroundLayer) {
            this.foregroundLayer.animate();
        }

        if(this.backgroundLayer) {
            this.backgroundLayer.animate();
        }
    }

}

export default AnimatedDotsConnections;
